import { Button, Card, Skeleton } from "@rumbledirect/ui-v2";
import { createFileRoute, Link } from "@tanstack/react-router";
import { getApiErrorStatus } from "@/lib/api/apiErrorStatus";
import { useGetRootCompaniesCompanyId } from "@/lib/api/generated/company/company";
import { RootCompanyEditor } from "@/rootCompanies/RootCompanyEditor";
import { parseRootCompaniesSearch } from "@/rootCompanies/rootCompaniesSearch";

export const Route = createFileRoute(
  "/_authenticated/platform-management_/companies_/$companyId",
)({ validateSearch: parseRootCompaniesSearch, component: CompanyRoute });

function CompanyRoute() {
  const { companyId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const query = useGetRootCompaniesCompanyId(companyId);
  if (query.isPending)
    return (
      <Card
        role="status"
        aria-label="Bedrijf laden"
        aria-live="polite"
        className="space-y-6 p-6"
      >
        <Skeleton className="h-20 w-full" />
        <Skeleton className="h-64 w-full" />
      </Card>
    );
  if (query.isError && !query.data)
    return (
      <Card role="alert" className="space-y-4 p-6">
        <p>
          {getApiErrorStatus(query.error) === 404
            ? "Dit bedrijf bestaat niet."
            : "We konden dit bedrijf niet laden."}
        </p>
        <Link to="/platform-management/companies" search={search}>
          Terug naar bedrijven
        </Link>
        {getApiErrorStatus(query.error) !== 404 && (
          <Button variant="outline" onClick={() => void query.refetch()}>
            Opnieuw proberen
          </Button>
        )}
      </Card>
    );
  return (
    <>
      {query.isError && (
        <Card role="alert" className="mb-6 space-y-4 p-6">
          <p>We konden dit bedrijf niet vernieuwen.</p>
          <Button variant="outline" onClick={() => void query.refetch()}>
            Opnieuw proberen
          </Button>
        </Card>
      )}
      <RootCompanyEditor
        key={companyId}
        company={query.data}
        onBack={() => {
          void navigate({ to: "/platform-management/companies", search });
        }}
      />
    </>
  );
}
